<template>
  <div class="car-content car-main-tab-content car-reduced-width">
    <back-btn />

    <div class="car-selection-overview">
      <selected-vehicle-tile />
      <selected-region-tile />
      <selected-services-tile />
    </div>

    <div class="car-form-container car-equipment-selection">
      <div class="car-content-introduction">
        <span class="car-headline">
          {{$t('equipmentSelection.title')}}
        </span>
        <p>{{$t('equipmentSelection.description')}}</p>
      </div>
      <div data-js="equipment-selection" class="car-equipment-selection">

        <div v-for="(option) in equipmentOption.options" :key="option.avGroup">
          <equipment-select :change="updateAvs"  :option="option" />
        </div>

        <spinner v-if="loading" class="car-spinner car-content-spinner" />

        <div class="car-form-error-message" v-if="equipmentError">{{$t('equipmentSelection.error.equipmentError')}}</div>
        <div class="car-form-error-message" v-if="requestError">{{$t('equipmentSelection.error.requestError')}}</div>
        <div class="car-form-error-message" v-if="noOffersError">{{$t('equipmentSelection.error.noOffersError')}}</div>
        <div class="car-form-error-message" v-if="formError">{{$t('equipmentSelection.error.formError')}}</div>
      </div>

      <div class="car-form-buttons car-buttons">
        <primary-btn
          @click="goNext"
          class="car-btn-primary"
          data-js="equipment-selection__container--btn"
          :loading="loadingOffer">
          {{$t('serviceSelection.button')}}
        </primary-btn>
        <div class="car-form-required">* {{ $t('catalogSelection.requiredNote') }}</div>
      </div>
    </div>

    </div>
</template>

<script>
import _ from 'lodash';
import EquipmentSelect from '@/components/equipmentSelection/EquipmentSelect';
import { mapGetters } from 'vuex';
import equipmentService from '@/services/equipmentService';
import Spinner from 'vue-simple-spinner';
import BackBtn from '@/components/BackBtn';
import SelectedServicesTile from '@/components/serviceSelection/SelectedServicesTile';
import SelectedVehicleTile from '@/components/vehicleIdentification/SelectedVehicleTile';
import SelectedRegionTile from '@/components/serviceSelection/SelectedRegionTile';
import PrimaryBtn from '@/components/PrimaryBtn';

export default {
  name: 'EquipmentSelection',
  data: function () {
    return {
      disabled: false,
      requestError: false,
      noOffersError: false,
      equipmentError: false,
      formError: false,
      loading: false,
      loadingOffer: false
    }
  },
  methods: {
    goNext: function() {
      if (this.equipmentOption.options) {
        let valid = this.isValid(true);
        this.noOffersError = false;
        this.requestError = false;
        this.formError = false;
        if (!valid || this.loading) {
          if (!valid) this.formError = true;
          return;
        }
      }
      this.$store.dispatch('vehicleEquipments/setVehicleEquipmentList', this.getVehicleEquipmentList());
      this.loadingOffer = true;
      return this.$store.dispatch('offer/getOfferList')
        .then((res) => {
          if (res.data.length === 0) {
            this.noOffersError = true;
          }
          this.$router.push({
            name: 'OfferSelection',
            params: { searchKey: res.data[0].offerSearchKey }
          });
        })
        .catch((err) => {
          this.requestError = true;
          return Promise.reject(new Error(err));
        }).finally(() => {
          this.loadingOffer = false;
        })
    },
    updateAvs: function(option, isNotSelectedManually) {
      this.$store.dispatch('vehicleEquipments/setTemporaryEquipmentAvs', option);
      let nextGroup = this.getNextAvGroup(option);
      this.equipmentError = false;
      if (!isNotSelectedManually) option.selectedManually = true;
      if (nextGroup) {
        this.loading = true;
        this.$store.dispatch('vehicleEquipments/hideAvGroupsIfDisplayed', nextGroup);
        let params = {
          selectedAvIds: this.getSelectedAvs(nextGroup),
          avGroups: nextGroup.avGroup
        };
        this.$store.dispatch('vehicleEquipments/getAvsByGroup', params)
          .then((res) => {
            let params = {
              avGroup: nextGroup.avGroup,
              data: res.data
            };
            this.$store.dispatch('vehicleEquipments/updateAvsGroup', params);
            if (!res.data.options) {
              this.updateAvs(nextGroup);
            } else {
              this.disabled = !this.isValid();
            }
          })
          .catch(() => {
            this.equipmentError = true;
          })
          .finally(() => { this.loading = false });
      } else {
        this.disabled = !this.isValid();
      }
      this.$forceUpdate();
    },
    getNextAvGroup: function (option) {
      let index = _.findIndex(this.equipmentOption.options, { avGroup: option.avGroup });
      if (index > -1) {
        let nextAvGroup = this.equipmentOption.options[index + 1];
        if (nextAvGroup) {
          return nextAvGroup;
        }
      }
    },
    getSelectedAvs: function (nextGroup) {
      let selectedAvIds = [];
      _.each(this.equipmentOption.options, (avGroup) => {
        selectedAvIds.push(avGroup.selections.map(selection => {
          if (avGroup.show && avGroup.order < nextGroup.order && selection.selectedAvs !== '-1') {
            return selection.selectedAvs
          }
        }));
      });
      return _.uniq(_.flatten(selectedAvIds));
    },
    getVehicleEquipmentList: function () {
      let equipmentList = [];
      equipmentList = _.map(this.defaultAvEquipments, (e) => {
        return {
          equipmentCode: e.av,
          selected: true
        };
      });
      _.each(this.equipmentOption.options, (option) => {
        _.each(option.selections, (selection) => {
          if (typeof selection.selectedAvs === 'string' && selection.selectedAvs !== '-1') {
            let equipment = {};
            let selectedAv = _.find(selection.avs, { av: { id: selection.selectedAvs } });
            equipment.equipmentCode = selectedAv.av.av;
            equipment.selected = true;
            equipmentList.push(equipment);
          } else {
            _.each(selection.selectedAvs, (avs) => {
              let equipment = {};
              let selectedAv = _.find(selection.avs, { av: { id: avs } });
              if (selectedAv) {
                equipment.equipmentCode = selectedAv.av.av;
                equipment.selected = true;
                equipmentList.push(equipment);
              }
            });
          }
        })
      });
      _.each(this.equipmentOption.mandatoryAvs, (av) => {
        let equipment = {
          equipmentCode: av.av,
          selected: true
        };
        equipmentList.push(equipment);
      });
      return equipmentList;
    },
    isValid: function (displayError) {
      let valid = true;
      if (this.equipmentOption.options) {
        _.each(this.equipmentOption.options, (option) => {
          if (option.show) {
            _.each(option.selections, (selection) => {
              if (!selection.selectedAvs || selection.selectedAvs.length === 0) {
                if (displayError) {
                  this.$set(selection, 'error', true);
                }
                valid = false;
              } else {
                this.$set(selection, 'error', false);
              }
            });
          }
        });
      }
      return valid;
    }
  },
  components: {
    EquipmentSelect,
    Spinner,
    BackBtn,
    SelectedVehicleTile,
    SelectedServicesTile,
    SelectedRegionTile,
    PrimaryBtn
  },
  computed: {
    ...mapGetters('vehicleEquipments', {
      defaultAvEquipments: 'defaultAvEquipments',
      temporaryEquipmentAvs: 'temporaryEquipmentAvs'
    }),
    equipmentOption() {
      let selectedEquipments = this.$store.getters['vehicleEquipments/temporaryEquipmentAvs'];
      let avs = this.$store.getters['vehicleEquipments/avs'];

      // each equipment found in the temporary equipments array should be automatically selected
      equipmentService.autoSelectEquipments(selectedEquipments, avs, this.updateAvs);

      return avs;
    }
  }
};
</script>
